/**
 * Created by Filip de Tillier on 12.12.2018.
*/
import _ from 'underscore';
import Vue from 'vue';
import getMixin from 'underscore.get';
import axios from 'axios';

_.mixin(getMixin);
/**
 * @module Store/view
 * @description Module for filters
*/
/**
 * @constant State of orders store
 * @type {object}
* */
const state = {
    filters: {},
    sortOrder: {
        field: 'name',
        direction: 'asc'
    },
    activeKeyAccountShops:undefined,
    showOffline: false,
    page: 1,
    filtredShops: [],
    currentShop: {},
    currentShopFormIsValid: {
        shopForm: false,
        setupManager: false
    },
    socketInfo: {},
    cubeInfo: {},
    cubes: [],
    activeKeyAccount: undefined,
    selectedShops: [],
    shopDevices: undefined,
    cubesStatus: [],
    dataFromSockets: [],
};
/**
 * @constant Getters
 * @type {object}
**/
const getters = {
    getShopsTableFilters: state => state.filters,
    getShopsTableSortOrder: state => state.sortOrder,
    getShopsIncludingFilters: state => state.filtredShops,
    getShopsTablePage: state => state.page,
    currentShop: state => state.currentShop,
    getCurrentShopEnabledProperty: state => state.currentShop.enabled,
    getCurrentShopFormIsValid: state => state.currentShopFormIsValid,
    getActiveKeyAccount: state => state.activeKeyAccount,
    getSelectedShops: state => state.selectedShops,
    getShopDevices: state => state.shopDevices,
    getSocketInfo: state => state.socketInfo,
    getCubeInfo: state => state.cubeInfo,
    getCubesStatus: state => state.cubesStatus,
    getDataFromSockets: state => state.dataFromSockets,
};
/**
 * @constant Mutations
 * @type {object}
**/
const mutations = {
    addShopsTableFilters: (state, filters) => state.filters = filters,
    setShopsTableSortOrder: (state, sortOrder) => state.sortOrder = sortOrder,
    setShopsIncludingFilters: (state, filtredShops) => state.filtredShops = filtredShops,
    setCubes: (state, cubes) => state.cubes = cubes,
    setShopsTablePage: (state, page) => state.page = page,
    currentShop: (state, currentShop) => state.currentShop = currentShop,
    setSelectedShops: (state, selected) => state.selectedShops = selected,
    setShowOffline: (state, d) => state.showOffline = d,
    setActiveKeyAccountShops: (state, keyAccount) => state.activeKeyAccountShops = keyAccount,
    setCurrentShopFormIsValidShopForm: (state, isValid) => state.currentShopFormIsValid.shopForm = isValid,
    setCurrentShopFormIsValidSetupManager: (state, isValid) => state.currentShopFormIsValid.setupManager = isValid,
    setShopDevices: (state, devices) => state.shopDevices = devices,
    setSocketInfo: (state, data) => state.socketInfo = data,
    setCubeInfo: (state, data) => state.cubeInfo = data,
    setDataFromSockets: (state, data) =>{
        state.dataFromSockets.push(data)
    },
    setCubesStatus: (state, status) => {
        const { cube } = status;
        state.cubesStatus = Object.assign({}, state.cubesStatus, { [cube]: status });
    }
};
/**w
 * @constant Actions
 * @type {object}
**/
const actions = {
    changeActiveKeyAccountShops ({ commit }, keyAccount) {
        commit('setActiveKeyAccountShops', keyAccount);
    },
    GetCubesById ({ state }, id) {
        return state.cubes;
    },
    AddShopsTableFilters ({ commit }, filters) {
        commit('addShopsTableFilters', filters);
    },
    SetShopsTableSortOrder ({ commit }, sortOrder) {
        commit('setShopsTableSortOrder', sortOrder);
    },
    SaveSelectedShops ({ commit }, { list }) {
        commit('setSelectedShops', list);
    },
    SetShowOffline ({ commit, state }, data) {
        commit('setShowOffline', data);
        if (data) {
            const filtered = [];
            _.each(state.filtredShops, (v) => {
                if (!state.cubes.hasOwnProperty(v.id)) {
                    filtered.push(v);
                }
            });
            commit('setShopsIncludingFilters', filtered);
        }
    },
    socket_callerror ({ commit, state }, data) {
        state.socketInfo.push({ type: 'error', data: data });
    },
    socket_calldone ({ commit, state }, cubeData) {
        //console.log('cubeData', cubeData);
        const {data = {}, source = {}} = cubeData;
        const { message = undefined } = data;

        let cubehost;
        if(source.original && source.original.cubehost) {
            cubehost = source.original.cubehost;
        }
        if (typeof message === 'object') {
            const { cubename = '', media: mediaInfo = undefined, error = false, err = {} } = message;
            const [status, cube] = cubename.split(':');
            if(status === 'cubestatus' || (error && err)) {
                commit('setCubesStatus', { cube:cubehost, media:false, pages:0, timestamp: Date.now(), error, err, lifecounter: 0 });
            }
            if (!mediaInfo) {
                return;
            }
            let info = mediaInfo;
            if(typeof mediaInfo === 'string'|| mediaInfo instanceof String) {
                try {
                    info = JSON.parse(mediaInfo);
                } catch(err) {
                    info = undefined;
                }
            }
            const { media = '', pages = '', lifecounter = '' } = info;
            if (status === 'cubestatus') {
                commit('setCubesStatus', { cube:cubehost, media, pages, timestamp: Date.now(), lifecounter });
            }
        }
        if (data.type) {
            commit('setSocketInfo', { type: data.type, data: data });

            const dataToSave = {
                context: source.original?.context,
                setup: source.original?.setup,
                teamviewer: source.original?.teamviewer,
                hostname: source.original?.cubehost,
                message: message,
                type: data.type,
            }
            commit('setDataFromSockets', dataToSave);
            return;
        }
        commit('setSocketInfo', { type: 'done', data: data });
    },
    /*socket_cubes ({ commit, state }, data) {
        const stores = {};
        for (const c of Object.keys(data)) {
            data[c].name = c;
            data[c].installer = data[c].original && data[c].original.installer;
            if (stores[data[c].context]) {
                stores[data[c].context].list.push(data[c]);
            } else {
                stores[data[c].context] = {
                    list: [data[c]]
                };
            }
        }
        commit('setCubes', stores);
    },*/
    SetShopsIncludingFilters ({ commit, state }, data) {
        const { filters } = state;
        let filteredShops = data;
        if (data.length > 0) {
            _.each(Object.values(filters), filter => {
                if (filter.hasOwnProperty('value')) {
                    filteredShops = _.filter(filteredShops, single => {
                        if (filter.value !== '') {
                            const field = _.get(single, filter.field);
                            if (field) {
                                return field.toLowerCase().indexOf(filter.value.toLowerCase()) > -1;
                            }
                            return false;
                        }
                        return true;
                    });
                }
            });
        }
        filteredShops = filteredShops.map((v) => {
            v.online = state.cubes.hasOwnProperty(v.id);
            return v;
        });
        commit('setShopsIncludingFilters', filteredShops);
    },
    SetShopsTablePage ({ commit }, page) {
        commit('setShopsTablePage', page);
    },
    CurrentShop ({ commit }, shop) {
        commit('currentShop', shop);
    },
    async GetShopDevices ({commit}, context=undefined) {
        const defaultDevice = [
            { name: 'Shop Icon', context: context, symbol: 'shop_icon', link: '', active: true },
            { name: 'Receipt banner', context: context, symbol: 'receipt_banner', link: '', active: true }
            // { name: 'Advertisement', context: context, symbol: 'advertisement', link: '', active: true },
            // { name: 'Printer Device', context: context, symbol: 'rs1', link: '' },
            // { name: 'Printer Device', context: context, symbol: 'ds820', link: '' }
        ];

        const images = [
            { name: 'Shop Icon', context: context, symbol: 'shop_icon', link: '', active: true },
            { name: 'Receipt banner', context: context, symbol: 'receipt_banner', link: '', active: true }
        ];
        let {data: {results}} = await Vue.axios.get('/collecter/classes/symbols', {
            params: { where: { context }},
            headers: {'X-Parse-Application-Id': 'uGJEQnHj5DajteynrhvzAXnMH8'}
        });
        const symbols = results.map(item => item.symbol);

        if(results.length){
            images.forEach(item => {
                if(symbols.indexOf(item.symbol) === -1) {
                    results.push(item);
                }
            });
        }

        const result = [];
        const map = new Map();
        for (const item of results) {
            if(!map.has(item.symbol)){
                map.set(item.symbol, true);    // set any value to Map
                result.push(item);
            }
        }
        results = result;

        commit('setShopDevices', results.length > 0 ? results : defaultDevice);
        return results;
    },
    async UpdateShopDevices ({dispatch}, devices) {
        const devicesForUpdate = devices.filter(device => device.hasOwnProperty('objectId'));
        const devicesForAdd = devices.filter(device => !device.hasOwnProperty('objectId'));
        devicesForUpdate ? await devicesForUpdate.forEach(device => dispatch('PutShopDevices', device)) : null;
        devicesForAdd ? await devicesForAdd.forEach(device => dispatch('PostShopDevices', device)) : null;
    },
    async PutShopDevices ({ }, device) {
        function mapData ({ context, link, symbol }) {
            return { context, link, symbol };
        }
        const { data } = await Vue.axios.put(`/collecter/classes/symbols/${device.objectId}`, mapData(device), {
            headers: { 'X-Parse-Application-Id': 'uGJEQnHj5DajteynrhvzAXnMH8' }
        });
        return data;
    },
    async PostShopDevices ({ }, device) {
        const { data } = await Vue.axios.post('/collecter/classes/symbols', device, {
            headers: { 'X-Parse-Application-Id': 'uGJEQnHj5DajteynrhvzAXnMH8' }
        });
        return data;
    },
    async DeleteShopDevice ({ dispatch }, device) {
        const { data } = await Vue.axios.delete(`/collecter/classes/symbols/${device.objectId}`, {
            headers: { 'X-Parse-Application-Id': 'uGJEQnHj5DajteynrhvzAXnMH8' }
        });
        await Vue.axios.delete(`/filestorage${device.link.slice(device.link.lastIndexOf('/'))}`);
        dispatch('GetShopDevices', device.context);
        return data;
    }
};
export default {
    state,
    getters,
    mutations,
    actions
};
